module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"search-in":"Rechercher dans","search":"Rechercher dans la carte active...","no-results":"Aucun résultat.","in-layer-results":"Dans:","loading":"Chargement...","communes":"Communes"},"de":{}}')
  delete Component.options._Ctor
}
